import React from "react";
import {
  IZonalConfigPageProps,
  ICustomerPageState, ICustomerConfigResponse,
} from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";
import AddUpdateZonalConfigPage from "./AddUpdateZonalConfigPage";
import ZonalConfigList from "./ZonalConfigList";

export default class ZonalConfigsPage extends React.Component<
  IZonalConfigPageProps,
  ICustomerPageState
> {
  constructor(props: IZonalConfigPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedZonalConfig: null,
      isZonalConfigAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
      selectedCity: "",
      currentLocation: "",
    };
  }

  renderAddUpdateZonalConfigPage = () => {
    const { isEdit, selectedZonalConfig } = this.state;
    const {
      isLoading,
      isError,
      error,
      createZonalConfig,
      updateZonalConfig,
      isZonalConfigAdded,
      isZonalConfigUpdated,
      getZonalConfigDetails,
      isZonalConfigDetailsFetched,
      zonalConfigDetails,
      clearZonalConfigDetails,
      fetchCities,
      citiesList,
      isCityListFetched,
      getWarehouseCategories,
      warehouseCategories,
      isWarehouseCategoriesFetched,
      getZonalConfigChildZones,
      zonalConfigChildZones,
      isZonalConfigChildZonesFetched,
      getZonalConfigTowns,
      zonalConfigTowns,
      isZonalConfigTownsFetched,
      getZonalConfigWarehouse,
      isZonalConfigWarehouseNameFetched,
      zonalConfigWarehouseName,
      getBulkCustomerDetailsByIdAction,
      clearBulkCustomerDetailsAction,
      bulkCustomerDetails,
      isBulkCustomerDetailsFetched,
      getZonalConfigWarehouseListWithStorageBlocks,
      isZonalConfigWarehouseListWithStorageBlocksFetched,
      zonalConfigWarehouseListWithStorageBlocks,
      fetchCustomerConfig,
      getZoneCustomerChannelConfig,
      zonalConfigChannelName,
      isFetchCustomerChannelLoading
    } = this.props;
    const { selectedCity } = this.state;

    return (
      <AddUpdateZonalConfigPage
        {...this.props}
        zonalConfigs={selectedZonalConfig}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        createZonalConfig={createZonalConfig}
        updateZonalConfig={updateZonalConfig}
        isZonalConfigAdded={isZonalConfigAdded}
        isZonalConfigUpdated={isZonalConfigUpdated}
        getZonalConfigDetails={getZonalConfigDetails}
        isZonalConfigDetailsFetched={isZonalConfigDetailsFetched}
        zonalConfigDetails={zonalConfigDetails}
        clearZonalConfigDetails={clearZonalConfigDetails}
        fetchCities={fetchCities}
        citiesList={citiesList}
        isCityListFetched={isCityListFetched}
        selectedCity={selectedCity}
        getWarehouseCategories={getWarehouseCategories}
        warehouseCategories={warehouseCategories}
        isWarehouseCategoriesFetched={isWarehouseCategoriesFetched}
        getZonalConfigChildZones={getZonalConfigChildZones}
        zonalConfigChildZones={zonalConfigChildZones}
        isZonalConfigChildZonesFetched={isZonalConfigChildZonesFetched}
        getZonalConfigTowns={getZonalConfigTowns}
        zonalConfigTowns={zonalConfigTowns}
        isZonalConfigTownsFetched={isZonalConfigTownsFetched}
        getZonalConfigWarehouse={getZonalConfigWarehouse}
        isZonalConfigWarehouseNameFetched={isZonalConfigWarehouseNameFetched}
        zonalConfigWarehouseName={zonalConfigWarehouseName}
        getBulkCustomerDetailsByIdAction={getBulkCustomerDetailsByIdAction}
        clearBulkCustomerDetailsAction={clearBulkCustomerDetailsAction}
        bulkCustomerDetails={bulkCustomerDetails}
        isBulkCustomerDetailsFetched={isBulkCustomerDetailsFetched}
        getZonalConfigWarehouseListWithStorageBlocks={getZonalConfigWarehouseListWithStorageBlocks}
        isZonalConfigWarehouseListWithStorageBlocksFetched={isZonalConfigWarehouseListWithStorageBlocksFetched}
        zonalConfigWarehouseListWithStorageBlocks={zonalConfigWarehouseListWithStorageBlocks}
        fetchCustomerConfig={fetchCustomerConfig}
        getZoneCustomerChannelConfig={getZoneCustomerChannelConfig}
        zonalConfigChannelName={zonalConfigChannelName}
        isFetchCustomerChannelLoading={isFetchCustomerChannelLoading}

      />
    );
  };

  renderZonalConfigListing = () => {
    let props: any;
    const {
      zonalConfigs,
      isFetchZonalConfigsLoading,
      isFetchZonalConfigsError,
      error,
      pagination,
      isZonalConfigAdded,
      isZonalConfigUpdated,
      fetchZonalConfigs,
      citiesList,
      fetchCities,
      isCityListFetched,
      zonalConfigUpload,
      zonalCSVBatchUpload,
      isZonalConfigUploading,
      isZonalConfigUploaded,
      isZonalConfigUploadingError,
    } = this.props;
    const {
      isZonalConfigAddUpdate,
      searchText,
      currentListPosition,
      selectedCity,
      currentLocation,
    } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Zonal" isMainHeading={true} />
        </section>
        <ZonalConfigList
          fetchZonalConfigs={fetchZonalConfigs}
          zonalConfigs={zonalConfigs}
          pagination={pagination}
          isLoading={isFetchZonalConfigsLoading}
          isError={isFetchZonalConfigsError}
          error={error}
          isZonalConfigsAddedorUpdated={isZonalConfigAddUpdate}
          currentLocation={currentLocation}
          isZonalConfigAdded={isZonalConfigAdded}
          isZonalConfigUpdated={isZonalConfigUpdated}
          addUpdatePageHandler={this.toggleAddUpdateZonalConfigsPage}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
          selectedCity={selectedCity}
          citiesList={citiesList}
          fetchCities={fetchCities}
          isCityListFetched={isCityListFetched}
          zonalConfigUpload={zonalConfigUpload}
          zonalCSVBatchUpload={zonalCSVBatchUpload}
          isZonalConfigUploading={isZonalConfigUploading}
          isZonalConfigUploaded={isZonalConfigUploaded}
          isZonalConfigUploadingError={isZonalConfigUploadingError}
          {...props}
        />
      </>
    );
  };

  toggleAddUpdateZonalConfigsPage = (
    selectedCity: object = {},
    isEdit: boolean = false,
    selectedZonalConfig: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedZonalConfig: selectedZonalConfig,
      searchText: searchText,
      currentListPosition: currentScroll,
      selectedCity: selectedCity,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean, currentLocation: any) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isZonalConfigAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
      currentLocation: currentLocation,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateZonalConfigPage()
          : this.renderZonalConfigListing()}
      </div>
    );
  }
}
